import PropTypes from "prop-types";
import { createContext, useCallback, useContext, useMemo, useState } from "react";

const AssistantSessionContext = createContext(null);

export function AssistantSessionProvider({ children }) {
  const [dockOpen, setDockOpen] = useState(false);
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [proactiveInsights, setProactiveInsights] = useState([]);
  const [wizardState, setWizardState] = useState(null);
  const [insightsLoading, setInsightsLoading] = useState(false);
  const [llmOnline, setLlmOnline] = useState(null);
  const [lastWorkPath, setLastWorkPath] = useState("/dashboard");

  const resetConversation = useCallback((welcomeMessage) => {
    setMessages(welcomeMessage ? [welcomeMessage] : []);
    setWizardState(null);
    setInput("");
  }, []);

  const value = useMemo(
    () => ({
      dockOpen,
      setDockOpen,
      input,
      setInput,
      messages,
      setMessages,
      loading,
      setLoading,
      proactiveInsights,
      setProactiveInsights,
      wizardState,
      setWizardState,
      insightsLoading,
      setInsightsLoading,
      llmOnline,
      setLlmOnline,
      lastWorkPath,
      setLastWorkPath,
      resetConversation,
    }),
    [
      dockOpen,
      input,
      messages,
      loading,
      proactiveInsights,
      wizardState,
      insightsLoading,
      llmOnline,
      lastWorkPath,
      resetConversation,
    ]
  );

  return (
    <AssistantSessionContext.Provider value={value}>{children}</AssistantSessionContext.Provider>
  );
}

AssistantSessionProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useAssistantSession() {
  const ctx = useContext(AssistantSessionContext);
  if (!ctx) {
    throw new Error("useAssistantSession must be used within AssistantSessionProvider");
  }
  return ctx;
}
